<template>
  <el-menu
    :default-active="activeIndex"
    class="web-navigator"
    mode="horizontal"
    active-text-color="#3399ff"
    text-color=" #17181a"
  >
    <el-menu-item
      v-for="router in routers.children"
      :key="router.path"
      :index="router.path"
      @click="turnToPage(router)"
      >{{ generateTitle(router.meta.title) }}</el-menu-item
    >
  </el-menu>
</template>

<script>
import { generateTitle } from "@/utils/i18n";
export default {
  data() {
    return {
      routers: [],
    };
  },
  methods: {
    generateTitle,
    turnToPage(params) {
      this.$router.push({ path: params.path });
    },
  },
  computed: {
    activeIndex() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss">
.web-navigator.el-menu--horizontal {
  .el-menu-item {
    border-top: none;
    border-bottom: none;
    font-size: 18px;
  }
  .el-menu-item.is-active {
    border-top: 2px solid #3399ff;
    border-bottom: none;
  }
}
</style>
